const initialState = {
  clients: [],
  activeClient: null,
};

const Clients = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CLIENTS':
      return {
        ...state,
        clients: action.clients,
      };
    case 'SET_ACTIVE_CLIENT':
      return {
        ...state,
        activeClient: action.activeClient,
      };
    case 'RESET_ACTIVE_CLIENT':
      return {
        ...state,
        activeClient: null,
      };
    default:
      return state;
  }
};

export default Clients;
